// ------------------------------------
// Constants
// ------------------------------------
export const MEMBERS_GET_REQUEST = "MEMBERS_GET_REQUEST";
export const MEMBERS_GET_REQUEST_SUCCESS = "MEMBERS_GET_REQUEST_SUCCESS";
export const MEMBERS_GET_REQUEST_FAILURE = "MEMBERS_GET_REQUEST_FAILURE";
export const MEMBERS_GET_RESET = "MEMBERS_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(searchParams, resolve, reject) {
  return {
    type: MEMBERS_GET_REQUEST,
    searchParams,
    resolve,
    reject,
  };
}

export function requestSuccess(res) {
  return {
    type: MEMBERS_GET_REQUEST_SUCCESS,
    data: res,
  };
}

export function requestFailure(error) {
  return {
    type: MEMBERS_GET_REQUEST_FAILURE,
    error,
  };
}
